import { LinkedIn } from '@mui/icons-material'
import { FcPhone } from 'react-icons/fc'
import { RiWhatsappFill } from 'react-icons/ri'
import img from '../../../assets/talks.png'
import gmailIcon from '../../../assets/gmailLogo.png'
import { useNavigate } from 'react-router-dom'
import { useAllIconsQuery } from '../../../helpers/talkIconsApi'
import { useAllListensQuery } from '../../../helpers/ListenApi'
import { useState } from 'react'
import Loader from '../../../components/Loader/Loader'
import { Pagination } from '@mui/material'

const CodeTalks = () => {

  const navigate = useNavigate()

  const [page, setpage] = useState(1)

  const { data, isFetching } = useAllIconsQuery()
  const { data: listenData, isFetching: listenLoading } = useAllListensQuery(page)


  return (
    <div className="dark:bg-gray-900 transition-all duration-700">
      {isFetching ? <Loader text={'loading...'} height='95vh' /> : (
        <div className=' pt-[52px] md:pt-[67px] min-h-[84vh]'>

          <div className='min-h-[60vh] relative bg-red-500'>

            {/* Radiation effect */}
            <div className='absolute top-[-275px] right-[-150px] z-30'>
              <div className='relative min-h-[250px] min-w-[250px]'>
                <div class="multiple-pulse">
                  <div class="third-multiple-pulse"></div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className='max-w-screen-xl mx-auto'>

              <div className='py-9 md:py-14 px-4 md:px-5 grid grid-cols-1 md:grid-cols-2 gap-7 items-center'>
                <div >
                  <h1 className='font-bold text-white text-2xl md:text-4xl text-center md:text-left'>
                    CodeTalks
                  </h1>
                  <p className='text-gray-200 text-xs md:text-sm py-1 text-center md:text-left'>
                    Stellar Episodes with Tech Pundits and Visionaries
                  </p>
                  <div className='flex gap-3 mt-4 justify-center md:justify-start flex-wrap sm:max-w-[400px]'>
                    {data.icons.length > 0 && data.icons.map((item, i) => {
                      return <div
                        key={i}
                        onClick={() => window.open(item.link)}
                        className={'w-[50px] relative group h-[50px] rounded-full flex justify-center items-center bg-white cursor-pointer hover:scale-90 duration-700 hover:white-shadow'}
                      >
                        <img src={item.img} alt="icon" className='h-[26px]' />
                        <span id='k' className="group-hover:ping-once absolute rounded-full bg-slate-500 -z-20 duration-[800ms] opacity-75"></span>
                      </div>
                    })}
                  </div>
                </div>

                <div className='flex justify-center'>
                  <img src={img} alt="img"
                    className='w-[250px] md:w-[300px] h-[250px] md:h-[300px] cursor-pointer'
                    onClick={() => navigate('/contact-us')}
                  />
                </div>
              </div>

            </div>
          </div>

          <div className='max-w-screen-lg mx-auto py-7 px-5 lg:px-0'>
            {listenLoading ? <Loader height={'30vh'} /> : (
              <div className='space-y-4'>
                {listenData.listen.length > 0 && listenData.listen.map((item, i) => (
                  <div key={i} className='bg-[#f2f7fb] dark:bg-gray-700 flex flex-col lg:flex-row gap-3 justify-between items-center p-3 rounded-lg sm:hover:scale-105 duration-700 shadow-sm hover:shadow-lg hover:bg-white'>
                    <div className='flex flex-col md:flex-row gap-4 md:gap-7 items-center'>
                      <div>
                        <img src={item.image} alt="img" className='h-[140px] w-[140px] sm:hover:scale-95 rounded-md duration-700' />
                      </div>
                      <div className='sm:w-[570px]'>
                        <h5 className='text-gray-600 dark:text-gray-300 font-serif text-[16px]'>
                          #{item.hashtag}
                        </h5>
                        <h1 className='font-bold text-[18px] dark:text-white sm:text-[25px] text-red-500 line-clamp-2'>
                          {item.title}
                        </h1>
                        <p className='text-[15px] mt-1 text-gray-500 dark:text-gray-300 sm:line-clamp-3'>
                          {item.desc}
                        </p>
                      </div>
                    </div>
                    <div className='px-4'>
                      <button
                        onClick={() => window.open(item.link)}
                        className="rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[14px] md:text-[17px] border-yellow-500 text-black ">
                        <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-yellow-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                        <span className="relative text-yellow-500 group-hover:text-white transition duration-700 ease">Listen Now</span>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

      )}

      <div className='flex justify-center py-3 pb-8'>
        {listenData && listenData.resultPerPage < listenData.filteredListenCount && (

          <Pagination color='primary' size='medium'
            count={Math.ceil(listenData.totalListenCount / listenData.resultPerPage)}
            page={page}
            shape='rounded'
            onChange={(event, value) => setpage(value)}
            showLastButton showFirstButton hideNextButton hidePrevButton

          />
        )}
      </div>

    </div>
  )
}

export default CodeTalks